import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Holiday from '../../entities/booking/holiday';

interface HolidayState extends ListState<Holiday>{
    editHoliday:Holiday
}
class HolidayMutations extends ListMutations<Holiday>{

}
class HolidayModule extends ListModule<HolidayState,any,Holiday>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Holiday>(),
        loading:false,
        editHoliday:new Holiday()
    }
    actions={
        async getAll(context:ActionContext<HolidayState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Holiday/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Holiday>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<HolidayState,any>,payload:any){
            await Ajax.post('/api/services/app/Holiday/Create',payload.data);
        },
        async update(context:ActionContext<HolidayState,any>,payload:any){
            await Ajax.put('/api/services/app/Holiday/Update',payload.data);
        },
        async delete(context:ActionContext<HolidayState,any>,payload:any){
            await Ajax.delete('/api/services/app/Holiday/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<HolidayState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Holiday/Get?Id='+payload.id);
            return reponse.data.result as Holiday;
        }
    };
    mutations={
        setCurrentPage(state:HolidayState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:HolidayState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:HolidayState,holiday:Holiday){
            state.editHoliday=holiday;
        }
    }
}
const holidayModule=new HolidayModule();
export default holidayModule;